module.exports = __webpack_public_path__ + "img/logo_mobile.32b5752c.png";